var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barra"},[_c('img',{attrs:{"src":require("../../assets/icons/ic-search.png"),"alt":""}}),_c('input',{attrs:{"type":"text","name":"barra"},on:{"input":_vm.onChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }